import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Minus } from "@air/next-icons";
import { Checkbox } from "@air/primitive-checkbox";
import { memo, useCallback } from "react";
import { FILTER_ROW_CHECKBOX } from "~/constants/testIDs";
export const FilterRowWithCheckbox = /*#__PURE__*/ memo((param)=>{
    let { icon: Icon, onChange, label, isPartialSelected, isSelected } = param;
    const renderIndicator = useCallback(()=>{
        if (isPartialSelected) {
            return /*#__PURE__*/ _jsx(Minus, {});
        }
        return /*#__PURE__*/ _jsx(Check, {});
    }, [
        isPartialSelected
    ]);
    return /*#__PURE__*/ _jsxs("label", {
        className: "mb-0.5 flex cursor-pointer justify-between py-1.5 pl-1.5 pr-1",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    Icon && /*#__PURE__*/ _jsx(Icon, {
                        className: "size-4 shrink-0 text-grey-10"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-14 text-grey-12",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Checkbox, {
                renderIndicator: renderIndicator,
                "aria-label": label,
                checked: isSelected,
                "data-testid": "".concat(FILTER_ROW_CHECKBOX, "-").concat(label),
                onCheckedChange: onChange
            })
        ]
    });
});
FilterRowWithCheckbox.displayName = "FilterRowWithCheckbox";
